import React, { useState, useEffect } from 'react';
import { Wheel } from 'react-custom-roulette';
import Confetti from 'react-confetti';
import { useWindowSize } from 'react-use';
import { Button } from 'react-bootstrap';
import { fires } from '../../firebase';
import { useNavigate, useParams } from "react-router-dom";
import "firebase/firestore";



const backgroundColors = [
    "#8B5CF6",
    "#EC4899",
    "#10B981",
    "#F59E0B",
    "#3B82F6",
    "#EF4444",
    "#6366F1",
    "#D946EF",
    "#14B8A6",
    "#E11D48",
    "#A855F7",
    "#F97316",
    "#4F46E5",
    "#22C55E",
    "#E879F9",
    "#FACC15"
  ];

export default function LuckyDrawWheel() {
  const [mustSpin, setMustSpin] = useState(false);
  const [prizeNumber, setPrizeNumber] = useState(1);
  const [selectedPrize, setSelectedPrize] = useState(null);
  const { width, height } = useWindowSize();
  let { id } = useParams();
  const [ticketData, setTicketData] = useState([{option: "A"}]);

  const handleSpinClick = () => {
    const newPrizeNumber = Math.floor(Math.random() * ticketData.length);
    setPrizeNumber(newPrizeNumber);
    setMustSpin(true);
  };

  useEffect(() => {
    const fetchTickets = async () => {
      if (id != ""){
        const querySnapshot = await fires.collection("events").doc(id).collection("tickets").get()
        const tickets = querySnapshot.docs.map(doc => ({ option: doc.id, }));
        if (tickets.length == 0){

        }
        else{
            setTicketData(tickets)
        }
      }
      else{
        setTicketData([{option: "A"}]);
      }
      
    };
    fetchTickets();
  }, []);

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gradient-to-br from-indigo-100 via-purple-100 to-pink-100 p-4">
      {selectedPrize && <Confetti width={width} height={height} numberOfPieces={300} recycle={false} />}

      <h1 className="text-4xl font-bold text-purple-700 mb-6 text-center">🎡 EventGo Lucky Draw</h1>

      <div className="d-flex align-items-center justify-content-center mb-6 mt-3" style={{}}>
        <Wheel
          mustStartSpinning={mustSpin}
          prizeNumber={prizeNumber}
          data={ticketData}
          backgroundColors={backgroundColors}
          textColors={["#ffffff"]}
          onStopSpinning={() => {
            setMustSpin(false);
            setSelectedPrize(ticketData[prizeNumber].option);
          }}
        />
      </div>

      {!selectedPrize && 
      
      <div className="d-flex align-items-center justify-content-center mt-3 mb-4" >
      <Button
        onClick={handleSpinClick}
        style={{backgroundColor: 'red', width: 120}}
        variant={"dark"}
      >
        Spin
      </Button>
      </div>
      }
      

      {selectedPrize && 
      
      <div className="d-flex align-items-center justify-content-center mt-3 mb-4" >
      <Button
        onClick={handleSpinClick}
        style={{backgroundColor: 'red', width: 120, borderColor: 'white', marginRight: 5}}
        variant={"dark"}
      >
        Claim
      </Button>
      <Button
        onClick={()=>{
            setSelectedPrize(null)
        }}
        style={{width: 120, borderColor: 'white'}}
        variant={"dark"}
      >
        Cancel
      </Button>
      </div>}

      {selectedPrize && (
        <div className="mt-6 text-2xl font-medium text-green-700 text-center">
          🎉 You won: <span className="font-bold">{selectedPrize}</span>
        </div>
      )}
      

      
    </div>
  );
}
